import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CreatePhotos.css";

export default function CreatePhotos() {
    const navigate = useNavigate();

    const token = sessionStorage.getItem("adminToken");

    const [mainImage, setMainImage] = useState(null);
    const [mainCaption, setMainCaption] = useState("");
    const [nestedGroups, setNestedGroups] = useState([]);

    const handleMainImage = (e) => {
        setMainImage(e.target.files[0]);
    };

    const addGroup = () => {
        setNestedGroups([...nestedGroups, { images: [] }]);
    };

    const handleNestedImages = (index, files) => {
        const updated = [...nestedGroups];
        updated[index].images = Array.from(files);
        setNestedGroups(updated);
    };

    const handleSubmit = async () => {
        try {
            if (!mainImage) {
                alert("Main image required");
                return;
            }



            const formData = new FormData();

            formData.append("mainImage", mainImage);
            formData.append("mainCaption", mainCaption);

            nestedGroups.forEach((group, index) => {
                group.images.forEach((file) => {
                    formData.append(`nested_${index}`, file);
                });
            });

            let response = await fetch(
                "http://localhost:8000/api/v1/postImage",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: formData,
                }
            );

            let data = await response.json();
            console.log(data);

            if (!response.ok) {
                alert(data.message || "Upload failed");
                return;
            }

            alert("Uploaded successfully!");
        } catch (error) {
            console.error(error);
            alert("Upload failed!");
        }
    };

    return (
        <div className="create-container">

            <button
                className="back-btn"
                onClick={() => navigate("/ManagePhotos")}
            >
                ← Back
            </button>

            <h2>Create Photos</h2>

            {/* ✅ TWO COLUMN LAYOUT */}
            <div className="form-layout">

                {/* LEFT SIDE */}
                <div className="left-panel">
                    <h3>Main Image</h3>

                    <input type="file" onChange={handleMainImage} />

                    <input
                        type="text"
                        placeholder="Enter caption..."
                        value={mainCaption}
                        onChange={(e) => setMainCaption(e.target.value)}
                    />

                    {mainImage && (
                        <img
                            src={URL.createObjectURL(mainImage)}
                            alt=""
                            className="preview-main"
                        />
                    )}
                </div>

                {/* RIGHT SIDE */}
                <div className="right-panel">
                    <h3>Nested Image Groups</h3>

                    <button className="add-btn" onClick={addGroup}>
                        + Add Group
                    </button>

                    {nestedGroups.map((group, index) => (
                        <div key={index} className="group-box">
                            <input
                                type="file"
                                multiple
                                onChange={(e) =>
                                    handleNestedImages(index, e.target.files)
                                }
                            />

                            <div className="preview-row">
                                {group.images.map((img, i) => (
                                    <img
                                        key={i}
                                        src={URL.createObjectURL(img)}
                                        alt=""
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            {/* ✅ SUBMIT stays bottom full width */}
            <button className="submit-btn" onClick={handleSubmit}>
                Upload
            </button>

        </div>
    );
}